import React, { useEffect } from "react";
import LinearProgress from "@mui/material/LinearProgress";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { styled } from "@mui/system";
import i18n from "multilingual";

const ProgressBar = ({ progress, progressMessage, step = 0, totalSteps = 3, customSx = {}, showSteps = true }) => {
  return (
    <Box
      sx={{ width: "100%", textAlign: "center", position: "relative", ...customSx }}
    >
      {progressMessage && (
        <Typography variant="body2">
          <span className="ml-2">
            {i18n.t(progressMessage)}
            <span className="blinking-dots">
              <span className="blinking-dot-1 fs-3">.</span>
              <span className="blinking-dot-2 fs-3">.</span>
              <span className="blinking-dot-3 fs-3">.</span>
            </span>
          </span>
        </Typography>
      )}
      <BaseProgress>
        <DeterminateProgress
          sx={{
            width: `${progress}%`,
          }}
        />
        {progress < 100 && (
          <IndeterminateProgress
            variant="indeterminate"
            sx={{ clipPath: `inset(0 ${100 - progress}% 0 0)` }}
          />
        )}
      </BaseProgress>
      {showSteps && (
        <Typography
          variant="body2"
          sx={{ mt: 1 }}
        >{i18n?.t('common.STEP_OF_TOTALSTEPS', { step, totalSteps })} </Typography>
      )}
    </Box>
  );
};

const BaseProgress = styled(Box)(({ theme }) => ({
  position: "relative",
  height: "10px",
  borderRadius: "5px",
  backgroundColor: "rgba(214, 347, 250, 0.3)",
}));

const DeterminateProgress = styled(Box)(({ theme }) => ({
  position: "absolute",
  top: 0,
  left: 0,
  height: "100%",
  borderRadius: "4px",
  background: "linear-gradient(to right, #8B08F4, #4C23D9)",
  transition: "width 0.3s ease",
}));

const IndeterminateProgress = styled(LinearProgress)(({ theme }) => ({
  position: "absolute",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  borderRadius: "5px",
  backgroundColor: "rgba(224, 247, 250, 0.2)",
  "& .MuiLinearProgress-bar1Indeterminate": {
    backgroundColor: "rgba(255, 255, 255, 0.5)",
  },
  "& .MuiLinearProgress-bar2Indeterminate": {
    display: "none",
  },
}));

export default ProgressBar;
